
import { Link } from 'react-router-dom';

export default function SubmitEventHero() {
  return (
    <section className="relative bg-gradient-to-br from-teal-700 to-teal-500 py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c1b68a3755a714dbf70c512643850d02.jpg"
          alt="Community events in Roseville"
          className="w-full h-full object-cover object-top opacity-20"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-1.5 rounded-full text-sm font-medium mb-6">
          <i className="ri-calendar-event-line"></i>
          Free Community Submissions
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
          Submit Your Event to Roseville
        </h1>
        <p className="text-teal-100 text-lg max-w-2xl mx-auto mb-8">
          Share your event with thousands of Roseville residents. Community events, workshops, festivals, and more — get listed on our calendar for free.
        </p>
        <div className="flex flex-wrap justify-center gap-6 text-white text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-lg"></i>
            <span>Free to submit</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-lg"></i>
            <span>Reviewed within 24 hours</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-lg"></i>
            <span>Reach thousands of locals</span>
          </div>
        </div>
        <div className="mt-6 text-teal-100 text-sm">
          Want premium placement?{' '}
          <Link to="/promote-event" className="text-white underline hover:text-teal-200 transition-colors">
            Promote your event →
          </Link>
        </div>
      </div>
    </section>
  );
}
